import { render, staticRenderFns } from "./trainingModulePageInformationText1.vue?vue&type=template&id=65620256&scoped=true&"
import script from "./trainingModulePageInformationText1.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageInformationText1.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageInformationText1.vue?vue&type=style&index=0&id=65620256&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65620256",
  null
  
)

export default component.exports